if (!customElements.get('adev-cart-drawer-recommended')) {
    customElements.define('adev-cart-drawer-recommended', class adevCartDrawerRecommended extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            const cart = this.closest('adev-cart-drawer');
            if (!cart) return;

            this.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        this.handleInView();
                        this.observer.disconnect();
                    }
                });
            });

            this.observer.observe(cart);
        }

        disconnectedCallback() {
            if (this.observer) {
                this.observer.disconnect();
            }
        }

        handleInView() {
            const url = this.dataset.url;
            if (!url) return;

            const innerEl = this.querySelector('[data-adev-cart-drawer-recommended="inner"]');
            if (!innerEl) return;

            fetch(url)
                .then(response => response.text())
                .then(html => {
                    const domParser = new DOMParser();
                    const doc = domParser.parseFromString(html, 'text/html');
                    const productsEl = doc.querySelector('[data-adev-cart-drawer-recommended="products"]');

                    innerEl.innerHTML = '';

                    if (productsEl) {
                        innerEl.innerHTML = productsEl.innerHTML;
                    }

                    this.classList.add('is--loaded');
                })
                .catch(error => {
                    console.error('Error fetching recommended products:', error);
                });
        }

    });
}
